import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_zh.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.zh-CN.js'
import 'moment/locale/zh-cn.js'
import './translations.tc.zh.js'

$.fn.datepicker.defaults.language = 'zh'

I18n.defaultLocale = 'zh'
I18n.locale = 'zh'

export default App
